module.exports = __webpack_public_path__ + "assets/img/ty2.66df2067.jpg";